import { Injectable, inject } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError, switchMap, take } from "rxjs/operators";
import { EMPTY, Observable, from, throwError, BehaviorSubject } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { ConfigService } from '../utils/config.service';

const TOKEN_HEADER_KEY = 'Authorization';
const TOKEN_HEADER_MODE = 'Bearer ';
@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  private auth = inject(AuthService);
  private cfg = inject(ConfigService);

  private loginUrl: string = this.cfg.get("loginUrl");
  private tokenUrl: string = this.cfg.get("tokenUrl");
  private refreshTokenUrl: string = this.cfg.get("refreshTokenUrl");
  private tokenUrlParameter: string = this.cfg.get("tokenUrlParameter");
  private configFile: string = this.cfg.get("configFile");
  private currentDisplayId: BehaviorSubject<string | undefined> = new BehaviorSubject<string | undefined>(undefined);

  constructor() {
    this.auth.getCurrentDisplayId().subscribe({
      next: value => {
        // if(!value ||!value.id || !value.type) return
        this.currentDisplayId.next(value)
      }
    })
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.includes(this.loginUrl) || req.url.includes(this.tokenUrl) || req.url.includes(this.refreshTokenUrl) || req.url.includes(this.tokenUrlParameter) || req.url.includes(this.configFile)) {
      return next.handle(req);
    }
    return from(this.auth.getToken()).pipe(
      take(1),
      switchMap(token => {
        if (token?.accessToken) {
          req = this.addTokenHeader(req, token.accessToken);
          req = this.addDisplayId(req);
        } else {
          this.auth.logout();
          return EMPTY;
        }
        return next.handle(req).pipe(
          catchError(error => {
            if (error instanceof HttpErrorResponse && error.status === 401) {
              return this.handle401Error(error);
            }
            return throwError(() => error); // REQUIRED TO DISPLAY LOGIN ERROR TEXT
          })
        );
      })
    );
  }

  private handle401Error(error: HttpErrorResponse) {
    this.auth.logout();
    return throwError(() => error);
  }

  private addTokenHeader(request: HttpRequest<any>, token: string) {
    /* for Spring Boot back-end */
    // return request.clone({ headers: request.headers.set(TOKEN_HEADER_KEY, 'Bearer ' + token) });
    /* for Node.js Express back-end */
    return request.clone({ headers: request.headers.set(TOKEN_HEADER_KEY, TOKEN_HEADER_MODE + token) });
  }

  private addDisplayId(request: HttpRequest<any>) {
    /*
        const displayID = await firstValueFrom(this.currentDisplay.pipe(filter(v => !!v)));
    */
    const displayID = this.currentDisplayId.getValue() ?? request.headers.get("DisplayId") ?? ''
    const clone = request.clone({
      headers: request.headers
        .set('DisplayId', displayID)
        .set('Source', 'Display')
    });
    return clone;
  }

}
